import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: '¡Hola!',
  ProductCode: 'speq42',
  Description: '<p>Here\'s all the online content included with your <strong>Spanish Exam Practice Workbook</strong>.</p>',
  Credits: 'With thanks to Encarna Aparicio-Dominguez and Lara Falomir Dominguez for the proofreading.\n' +
    '\n' +
    'Audio produced by Voice Talent Online.\n' +
    '\n' +
    'Questions throughout are based on Pearson Edexcel-type questions.\n' +
    '\n' +
    'Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2025. All rights reserved.'
};
